import { CRAWL_REQUEST_API_PREFIX } from '@aibees/elephant/constants';
import { HttpMethod } from '@aibees/shared/definition';
import { useDebounceFn, useNotify } from '@aibees/shared/hooks';
import { useBaseMutation } from '@aibees/shared/http';
import { baseQueryClient } from '@aibees/shared/http/base-query-client';
import { useWorkspace } from '@aibees/shared/workspace';
import { random } from 'lodash-es';
import { notificationIconMap } from '../utils';
import { useBrowseCrawlRequestsApi } from './use-browse-crawl-requests-api';

export function useRetryCrawlRequestMutationApi(id?: string) {
  const workspaceId = useWorkspace()?.id;
  const notify = useNotify();

  const invalidateDebounced = useDebounceFn(() => {
    baseQueryClient.invalidateQueries([useBrowseCrawlRequestsApi.name]);
  }, 2000);

  return useBaseMutation<any, never>(
    {
      url: `${CRAWL_REQUEST_API_PREFIX.replace(
        ':wid',
        String(workspaceId)
      )}/${id}?action=retry`,
      method: HttpMethod.patch,
    },
    {
      onSuccess: () => {
        invalidateDebounced();

        notify.progress(
          'Your crawl request is in progress',
          "Your request may take a few seconds to a few minutes. We'll notify you once it's done.",
          random(1, 101),
          {
            icon: notificationIconMap.CRAWL,
          }
        );
      },
      onError: (error) => {
        notify.error(error.message ?? 'Failed to retry crawl request.');
      },
    }
  );
}
